import { AppExtensionPreviewModule } from 'components/appExtensionPreview/appExtensionPreview.component';
import { AppExtensionConfirmInstallModule } from 'components/appExtensionPreview/appExtensionConfirmInstall.component';
import { AppExtensionUpgradePlanModule } from 'components/appExtensionPreview/appExtensionUpgradePlan.component';
import { AppsServiceModule } from 'services/data/apps.service';
import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';

export const LaunchAppExtensionPreviewServiceModule = angular
    .module('app.components.appExtensionPreview.launchAppExtensionModalService', [
        'ngMaterial',
        AppExtensionPreviewModule,
        AppExtensionConfirmInstallModule,
        AppExtensionUpgradePlanModule,
        AppsServiceModule,
        SubscriptionServiceModule
    ]).service('launchAppExtensionModalService', ($mdDialog, $q, appsService, subscriptionsService) => {
        return {
            launchPreview,
            launchConfirmInstall,
            launchUpgradePlan
        };

        function launchModal(options) {
            return $mdDialog.show({
                clickOutsideToClose: true,
                template: `
                    <md-dialog class="${options.cssClass}">
                        ${options.template}
                    </md-dialog>
                `,
                locals: {
                    app: options.app,
                    isInstalled: options.isInstalled
                },
                controller: ($scope, app, isInstalled) => {
                    'ngInject';

                    $scope.app = app;
                    $scope.isInstalled = isInstalled || false;
                }
            });
        }

        function launchPreview(type, app, isInstalled) {
            const modalPromise = launchModal({
                cssClass: 'modal--appExtension-preview',
                template: `
                    <app-extension-preview
                        layout="column"
                        app="app"
                        app-type="${type}"
                        is-installed="isInstalled">
                    </app-extension-preview>
                `,
                app,
                isInstalled
            });

            return $q.all([
                subscriptionsService.getSubscription(),
                appsService.getPurchasedApps(),
                modalPromise
            ]).then(([subscription, installedApps]) => {
                if (!isInstalled && subscriptionsService.appPlans[subscription.plan.name]) {
                    const maxAppCount = subscriptionsService.appPlans[subscription.plan.name].maxInstalledApps;

                    angular.element('body').addClass('data-plans--alternate');

                    if (installedApps.length >= maxAppCount) {
                        return launchUpgradePlan(type, app).catch(() => {});
                    }
                }

                return launchConfirmInstall(type, app, isInstalled);
            });
        }

        function launchConfirmInstall(type, app, isInstalled) {
            return launchModal({
                cssClass: 'modal--appExtension-confirm-install',
                template: `
                    <app-extension-confirm-install
                        layout="column"
                        app="app"
                        app-type="${type}"
                        is-installed="isInstalled">
                    </app-extension-confirm-install>
                `,
                app,
                isInstalled
            });
        }

        function launchUpgradePlan(type, app) {
            return launchModal({
                cssClass: 'modal--appExtension-upgrade-plan',
                template: `
                    <app-extension-upgrade-plan
                        layout="column"
                        app="app"
                        app-type="${type}"/>
                `,
                app
            });
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/appExtensionPreview/launchAppExtensionPreview.service.js